// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tp7CR","delete":"styles_delete__3FlVn","update":"styles_update__1MdrO","add":"styles_add__1MOwC"};